import { useRef } from "react";
import { TMenuIds } from "../../../../../app/state/menuSlice/types";
import { TEntityInfo } from "../../../../types/utility";
import { AddButton } from "../../../../Components/Buttons/AddButton";
import { AddStorageObjectMenu } from "../../AddStorageObjectMenu";
import styles from "./styles.module.css";
import { StorageScope } from "../../../../../services/api/instances/storageApi/types/service_types";

interface Props {
  isSidebarOpen: boolean;
  service: StorageScope;
  title?: string;
  withoutAddFolderButton?: boolean;
  onAdd?: () => void;
  handleOpenAddMenu?: (
    event: React.MouseEvent | HTMLElement,
    menuId: TMenuIds,
    info: TEntityInfo | null,
  ) => void;
  handleCloseMenu?: (id: TMenuIds) => void;
  handleOpenAddFolderModal?: () => void;
}

export const SidebarAddButton = ({
  isSidebarOpen,
  service,
  title,
  withoutAddFolderButton,
  onAdd,
  handleOpenAddMenu,
  handleCloseMenu,
  handleOpenAddFolderModal,
}: Props) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const openMenu = (event: React.MouseEvent) => {
    if (!handleOpenAddMenu) return;

    const target = event.currentTarget as HTMLElement;

    timerRef.current = setTimeout(() => {
      handleOpenAddMenu(target, "add_storage_object_menu", null);
    }, 200);
  };

  const cancelOpenMenu = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const closeMenu = () => {
    cancelOpenMenu();
    if (!withoutAddFolderButton && handleCloseMenu) {
      handleCloseMenu("add_storage_object_menu");
    }
  };

  const sidebarTitle =
    isSidebarOpen && title ? (
      <div className={styles["sidebar-title"]}>{title}</div>
    ) : !isSidebarOpen && title ? null : (
      <div>
        <AddButton
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            withoutAddFolderButton && onAdd ? onAdd() : openMenu(e);
          }}
          onMouseEnter={(e) => !withoutAddFolderButton && openMenu(e)}
          onMouseLeave={cancelOpenMenu}
          typeBtn={isSidebarOpen ? "text_btn" : "icon_btn"}
        />
        <AddStorageObjectMenu
          service={service}
          onAddObject={onAdd}
          closeMenu={closeMenu}
          handleOpenAddFolderModal={handleOpenAddFolderModal}
        />
      </div>
    );

  return <>{sidebarTitle}</>;
};
